import React from 'react';
import { Utilities, _Map } from '../../Utilities/Utilities';
import { ProgressBar, OverlayTrigger, Tooltip, Alert } from 'react-bootstrap';
import { getMyContest, getMiniLeagueMyContest } from '../../WSHelper/WSCallings';
import CountdownTimer from '../../views/CountDownTimer';
import CollectionSlider from "../../views/CollectionSlider";
import * as Constants from "../../helper/Constants";
import * as AppLabels from "../../helper/AppLabels";
import * as WSC from "../../WSHelper/WSConstants";
import Skeleton from 'react-loading-skeleton';
import { MomentDateComponent } from '../CustomComponent';
import Images from '../../components/images';


export default class UpcomingContest extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            upcomingContestList: [],
            loadingIndex: -1,
        };
    };

    /**
     * @description This function is responsible to get Live Contests response
     * @param status selected tab (Live, Upcoming, Completed)
     */
    getMyContestList(item, idx) {
        if (item.isExpanded) {
            let upcomingContestList = this.state.upcomingContestList;
            item['isExpanded'] = false;
            upcomingContestList[idx] = item;
            this.setState({ upcomingContestList })
        } else {
            if (item.contest && item.contest.length > 0) {
                let upcomingContestList = this.state.upcomingContestList;
                item['isExpanded'] = true;
                upcomingContestList[idx] = item;
                this.setState({ upcomingContestList })
            } else {
                var param = {
                    "sports_id": Constants.AppSelectedSport,
                    "status": 0,
                    "collection_master_id": item.collection_master_id
                }
                this.setState({ loadingIndex: idx })
                let apiStatus = Constants.SELECTED_GAMET == Constants.GameType.Free2Play ? getMiniLeagueMyContest : getMyContest
                apiStatus(param).then((responseJson) => {
                    this.setState({ loadingIndex: -1 })

                    if (responseJson && responseJson.response_code == WSC.successCode) {
                        let upcomingContestList = this.state.upcomingContestList;
                        item['contest'] = responseJson.data;
                        item['isExpanded'] = true;
                        upcomingContestList[idx] = item;
                        this.setState({ upcomingContestList })
                    }
                })
            }
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.upcomingContestList !== nextProps.upcomingContestList) {
            this.setState({ upcomingContestList: nextProps.upcomingContestList })
        }
    }
    getPrizeAmount = (prize_data) => {
        let prize_text = "Prizes";
        let is_tie_breaker = 0;
        let prizeAmount = { 'real': 0, 'bonus': 0, 'point': 0 };
        return (
            <React.Fragment>
                {
                    prize_data && prize_data.map(function (lObj, lKey) {
                        var amount = 0;
                        if (lObj.max_value) {
                            amount = parseFloat(lObj.max_value);
                        } else {
                            amount = parseFloat(lObj.amount);
                        }
                        if (lObj.prize_type == 3) {
                            is_tie_breaker = 1;
                        }
                        if (lObj.prize_type == 0) {
                            prizeAmount['bonus'] = parseFloat(prizeAmount['bonus']) + amount;
                        } else if (lObj.prize_type == 2) {
                            prizeAmount['point'] = parseFloat(prizeAmount['point']) + amount;
                        } else {
                            prizeAmount['real'] = parseFloat(prizeAmount['real']) + amount;
                        }
                    })
                }
                {
                    is_tie_breaker == 0 && prizeAmount.real > 0 ?
                        <span className="contest-prizes">{Utilities.getMasterData().currency_code}{parseFloat(prizeAmount.real).toFixed(0)}</span>
                        : is_tie_breaker == 0 && prizeAmount.bonus > 0 ? <span className="contest-prizes" ><i className="icon-bonus" width="13px" height="14px" />{parseFloat(prizeAmount.bonus).toFixed(0)}</span>
                            : is_tie_breaker == 0 && prizeAmount.point > 0 ? <span style={{ display: 'inlineBlock' }}> <img style={{ marginTop: '2px' }} src={Images.IC_COIN} width="12px" height="12px" />{parseFloat(prizeAmount.point).toFixed(0)}</span>
                                : AppLabels.PRIZES
                }
            </React.Fragment>
        )


    }

    render() {
        let { removeFromList, ContestDetailShow, getUserLineUpListApi, shareContest, switchTeamModalShow, openLineup } = this.props;

        return (
            <div>
                {
                    this.state.upcomingContestList.length > 0 &&
                    _Map(this.state.upcomingContestList, (item, idx) => {
                        return (
                            <div key={idx} className={"contest-card upcoming-contest-card-new" + (Constants.SELECTED_GAMET == Constants.GameType.MultiGame && item.match_list && item.match_list.length > 1 ? ' contest-card-with-collection' : '')}>
                                {
                                    item.custom_message != '' && item.custom_message != null &&
                                    <div className="bhopu-mycontest">
                                        <OverlayTrigger trigger={['click']} placement="left" overlay={
                                            <Tooltip id="tooltip" className="tooltip-featured">
                                                <strong>{item.custom_message} </strong>
                                            </Tooltip>
                                        }>
                                            <i className="icon-megaphone" onClick={(e) => e.stopPropagation()}></i>
                                        </OverlayTrigger>
                                    </div>

                                }
                                <div onClick={() => this.getMyContestList(item, idx)} className={"contest-card-header pointer-cursor" + (item.isExpanded ? ' pb15' : '')}>
                                    <ul>
                                        {(!item.match_list || item.match_list.length < 2) && <li className="team-left-side">
                                            {Constants.SELECTED_GAMET != Constants.GameType.MultiGame &&
                                                <React.Fragment>
                                                    <div className="team-content-img">
                                                        <img src={item.home_flag ? Utilities.teamFlagURL(item.home_flag) : ""} alt="" />
                                                    </div>
                                                    <div className="contest-details-action">
                                                        <div className="contest-details-first-div">{item.home}</div>
                                                    </div>
                                                </React.Fragment>
                                            }
                                            {Constants.SELECTED_GAMET == Constants.GameType.MultiGame && item.season_game_count > 1 &&
                                                <React.Fragment>
                                                    <div className="team-content-img">
                                                        <img src={item.match_list ? Utilities.teamFlagURL(item.match_list[0].home_flag) : ""} alt="" />
                                                    </div>
                                                    <div className="contest-details-action">
                                                        <div className="contest-details-first-div">{item.match_list ? item.match_list[0].home : ''}</div>
                                                    </div>
                                                </React.Fragment>
                                            }
                                            {Constants.SELECTED_GAMET == Constants.GameType.MultiGame && item.season_game_count <= 1 &&
                                                <React.Fragment>
                                                    <div className="team-content-img">
                                                        <img src={item.home_flag ? Utilities.teamFlagURL(item.home_flag) : ""} alt="" />
                                                    </div>
                                                    <div className="contest-details-action">
                                                        <div className="contest-details-first-div">{item.home}</div>
                                                    </div>
                                                </React.Fragment>
                                            }
                                        </li>
                                        }
                                        <li className="progress-middle">
                                            <div className="team-content">
                                                {(!item.match_list || item.match_list.length < 2) &&
                                                    <React.Fragment>
                                                        <p>
                                                            {item.league_name}
                                                            {/* {Constants.AppSelectedSport === '7' &&
                                                                <React.Fragment>- {Constants.MATCH_TYPE[item.format]}</React.Fragment>
                                                            } */}
                                                        </p>
                                                        {
                                                            Utilities.showCountDown(item) ?
                                                                <span>
                                                                    {item.game_starts_in && <CountdownTimer timerCallback={() => removeFromList(Constants.CONTEST_UPCOMING, idx)} deadlineTimeStamp={item.game_starts_in} />}
                                                                </span>
                                                                :
                                                                <span className="time-line-date"> <MomentDateComponent data={{ date: item.season_scheduled_date, format: "D MMM - hh:mm A" }} /> </span>
                                                        }
                                                    </React.Fragment>
                                                }
                                                {(Constants.SELECTED_GAMET == Constants.GameType.MultiGame && item.match_list && item.match_list.length > 1) &&
                                                    <React.Fragment>
                                                        <p className="collection_name">{item.collection_name}</p>
                                                        <div className="collection-match-info">
                                                            {item.match_list.length} {AppLabels.MATCHES_SM}
                                                            <span className="circle-divider"></span>
                                                            {item.league_name}
                                                        </div>
                                                    </React.Fragment>
                                                }
                                            </div>
                                        </li>

                                        {(!item.match_list || item.match_list.length < 2) && <li className="team-right-side">

                                            {Constants.SELECTED_GAMET != Constants.GameType.MultiGame &&
                                                <React.Fragment>
                                                    <div className="contest-details-action">
                                                        <div className="contest-details-first-div">{item.away}</div>
                                                    </div>
                                                    <div className="team-content-img">
                                                        <img src={item.away_flag ? Utilities.teamFlagURL(item.away_flag) : ""} alt="" />
                                                    </div>
                                                </React.Fragment>
                                            }
                                            {Constants.SELECTED_GAMET == Constants.GameType.MultiGame && item.season_game_count > 1 &&
                                                <React.Fragment>
                                                    <div className="contest-details-action">
                                                        <div className="contest-details-first-div">{item.match_list ? item.match_list[0].away : ''}</div>
                                                    </div>
                                                    <div className="team-content-img">
                                                        <img src={item.match_list ? Utilities.teamFlagURL(item.match_list ? item.match_list[0].away_flag : '') : ""} alt="" />
                                                    </div>
                                                </React.Fragment>
                                            }
                                            {Constants.SELECTED_GAMET == Constants.GameType.MultiGame && item.season_game_count <= 1 &&
                                                <React.Fragment>
                                                    <div className="contest-details-action">
                                                        <div className="contest-details-first-div">{item.away}</div>
                                                    </div>
                                                    <div className="team-content-img">
                                                        <img src={item.away_flag ? Utilities.teamFlagURL(item.away_flag) : ""} alt="" />
                                                    </div>
                                                </React.Fragment>
                                            }

                                        </li>
                                        }
                                    </ul>
                                </div>
                                {Constants.SELECTED_GAMET == Constants.GameType.MultiGame && item && item.match_list && item.match_list.length > 1 &&
                                    <div onClick={() => this.getMyContestList(item, idx)} className="mycontest-collection-wrapper">
                                        <CollectionSlider contestSliderData={item} collectionInfo={false} isFrom={'UpcomingContest'} />
                                    </div>
                                }


                                {item.isExpanded &&
                                    <div className="m-b-15 padding-strip">
                                        {
                                            item.custom_message != '' && item.custom_message != null &&
                                            <Alert variant="warning" className="alert-warning msg-alert-container">
                                                <div className="msg-alert-wrapper">
                                                    <span className=""><i className="icon-megaphone"></i></span>
                                                    <span>{item.custom_message}</span>
                                                </div>
                                            </Alert>

                                        }
                                    </div>
                                }
                                {



                                    item.isExpanded && _Map(item.contest, (childItem, idx) => {

                                        return (
                                            <div key={idx} className={"contest-card-body xmb20 ml15 mr15 " + (idx !== 0 ? "mt15" : '')}>
                                                <div className="contest-card-body-header cursor-pointer" onClick={() => ContestDetailShow(childItem, item)}>
                                                    <div className="contest-details">
                                                        <div className="contest-details-action">
                                                            {
                                                                childItem.contest_title ?
                                                                    <h4>
                                                                        {childItem.contest_title}
                                                                    </h4>
                                                                    :
                                                                    <h4><span className="text-capitalize">{AppLabels.WIN} </span>
                                                                        <span>
                                                                            {this.getPrizeAmount(childItem.prize_distibution_detail)}
                                                                        </span>
                                                                    </h4>
                                                            }
                                                            {
                                                                childItem.max_bonus_allowed != '0' &&
                                                                <span className="text-small text-italic-bold mt5">
                                                                    {childItem.max_bonus_allowed}{'% '}{AppLabels.BONUS}
                                                                </span>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="contest-progress-block">
                                                        <div className={"progress-bar-default" + (((parseInt(childItem.user_joined_count) < parseInt(childItem.multiple_lineup)) && (parseInt(childItem.size) > parseInt(childItem.total_user_joined))) ? '' : ' full-width-progress-bar')}>
                                                            <ProgressBar className={parseInt(childItem.total_user_joined) >= parseInt(childItem.minimum_size) ? '' : 'danger-area'} now={((100 / childItem.minimum_size) * childItem.total_user_joined)} />
                                                            <div className="progress-bar-value">
                                                                <span className="total-output">{childItem.total_user_joined}</span> / <span className="total-entries">{childItem.size} {AppLabels.ENTRIES}</span>
                                                                <span className="min-entries">{AppLabels.MIN} {childItem.minimum_size}</span>
                                                            </div>

                                                        </div>
                                                        {
                                                            ((parseInt(childItem.user_joined_count) < parseInt(childItem.multiple_lineup)) && (parseInt(childItem.size) > parseInt(childItem.total_user_joined))) ?
                                                                <button onClick={(event) => getUserLineUpListApi(event, item, childItem, "teamItem", true)} className="btn btn-primary pull-right width100">    {AppLabels.JOIN}
                                                                    {
                                                                        childItem.entry_fee > 0 ?
                                                                            <>
                                                                                {
                                                                                    childItem.currency_type == 2 ?
                                                                                        <img className="img-coin" alt='' src={Images.IC_COIN} />
                                                                                        :
                                                                                        Utilities.getMasterData().currency_code
                                                                                }
                                                                                {childItem.entry_fee}
                                                                            </>
                                                                            : AppLabels.FREE + ' '
                                                                    }

                                                                </button> : <div className=" width100">
                                                                    {
                                                                        childItem.entry_fee > 0 ?
                                                                            <><span style={{ fontWeight: 800 }}> Entry Fee </span>
                                                                                {
                                                                                    childItem.currency_type == 2 ?
                                                                                        <img className="img-coin" alt='' src={Images.IC_COIN} />
                                                                                        :
                                                                                        Utilities.getMasterData().currency_code
                                                                                }
                                                                                {childItem.entry_fee}
                                                                            </>
                                                                            : AppLabels.FREE + ' '
                                                                    }
                                                                </div>
                                                        }

                                                    </div>

                                                    {parseInt(childItem.total_user_joined) < parseInt(childItem.size) && Constants.SELECTED_GAMET != Constants.GameType.MultiGame && <a className="share-contest" href>

                                                        {Constants.SELECTED_GAMET != Constants.GameType.Free2Play && !childItem.is_network_contest &&
                                                            <i className="icon-share" onClick={(shareContestEvent) => shareContest(shareContestEvent, childItem)}></i>
                                                        }

                                                    </a>}
                                                    {
                                                        childItem.guaranteed_prize == 2 && parseInt(childItem.total_user_joined) >= parseInt(childItem.minimum_size) &&
                                                        <span className="featured-icon">G</span>
                                                    }
                                                    {
                                                        childItem.multiple_lineup > 1 &&
                                                        <span className="featured-icon">m</span>
                                                    }
                                                    {
                                                        childItem.is_private_contest == 1 &&
                                                        <span className="featured-icon">p</span>
                                                    }
                                                    {
                                                        childItem.is_confirmed == 1 && parseInt(childItem.total_user_joined) >= parseInt(childItem.minimum_size) &&
                                                        <span className="featured-icon">c</span>
                                                    }

                                                </div>
                                                <ul className="contest-listing upcoming">
                                                    {
                                                        _Map(childItem.teams, (teamItem, idx) => {

                                                            return (
                                                                <li key={idx}>
                                                                    <div className="cell-block">
                                                                        <a className="completed-user-link user-link cursor-default no-hover" href>{teamItem.team_name}</a>
                                                                    </div>
                                                                    <div className="cell-block contest-details-right">
                                                                        {
                                                                            Constants.SELECTED_GAMET == Constants.GameType.DFS && Utilities.getMasterData().a_guru == '1' && teamItem.is_pl_team && teamItem.is_pl_team == '1' &&
                                                                            <img style={{ marginTop: -20 }} src={Images.PL_LOGO} alt=''></img>
                                                                        }
                                                                        {
                                                                            Constants.SELECTED_GAMET != Constants.GameType.Free2Play &&
                                                                            <a href onClick={() => switchTeamModalShow(item, childItem, teamItem)}>
                                                                                <i className="icon-switch-team"></i>
                                                                                <span className='fs8 mt5'>{AppLabels.SWITCH_TEAM}</span>
                                                                            </a>
                                                                        }

                                                                        <a onClick={() => openLineup(item, childItem, teamItem, true, Constants.CONTEST_UPCOMING)}>
                                                                            <i className="icon-edit-line"></i>
                                                                            <span className='fs8 mt5'>{AppLabels.EDIT_TEAM}</span>
                                                                        </a>
                                                                        <a className="visible-for-mobile" onClick={() => openLineup(item, childItem, teamItem, false, Constants.CONTEST_UPCOMING, false)}>
                                                                            <i className="icon-ground"></i>
                                                                            <span className='fs8 mt5'>{AppLabels.VIEW_TEAM}</span>
                                                                        </a>

                                                                        <a className="visible-for-desktop" onClick={() => openLineup(item, childItem, teamItem, false, Constants.CONTEST_UPCOMING, true)}>
                                                                            <i className="icon-ground"></i>
                                                                            <span className='fs8 mt5'>{AppLabels.VIEW_TEAM}</span>
                                                                        </a>
                                                                    </div>
                                                                </li>
                                                            )
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                        );
                                    })
                                }
                                {

                                    (this.state.loadingIndex === idx) && <div className="contest-list m border shadow-none">
                                        <div className="shimmer-container">
                                            <div className="shimmer-top-view">
                                                <div className="shimmer-line">
                                                    <Skeleton height={9} />
                                                    <Skeleton height={6} />
                                                    <Skeleton height={4} width={100} />
                                                </div>
                                                <div className="shimmer-image">
                                                    <Skeleton width={30} height={30} />
                                                </div>
                                            </div>
                                            <div className="shimmer-bottom-view">
                                                <div className="progress-bar-default w-100">
                                                    <Skeleton height={6} />
                                                    <div className="d-flex justify-content-between">
                                                        <Skeleton height={4} width={60} />
                                                        <Skeleton height={4} width={60} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        )
                    })
                }
            </div>
        )
    }

}